import { ChunkyButton } from './Buttons.jsx';
import { BALL } from '../theme.js';

const T = BALL;

// Shown when Sentry's ErrorBoundary catches an unhandled render error.
// Keeps the user from staring at a blank screen and offers one obvious
// recovery path (reload).
export default function ErrorScreen({ resetError }) {
  return (
    <div className="app-shell" style={{
      alignItems: 'center', justifyContent: 'center', padding: 24, gap: 14,
      textAlign: 'center',
    }}>
      <div style={{ fontSize: 64 }}>🐶</div>
      <h1 style={{ fontSize: 24, fontWeight: 900, color: T.ink, margin: 0 }}>
        Något gick snett
      </h1>
      <p style={{ color: T.inkSoft, maxWidth: 320 }}>
        Appen råkade ut för ett fel. Vi har redan fått ett meddelande och
        tittar på det. Försök igen genom att ladda om.
      </p>
      <ChunkyButton color="primary" onClick={() => {
        resetError?.();
        location.reload();
      }}>
        Ladda om
      </ChunkyButton>
    </div>
  );
}
